import React, { useEffect, useState, useRef } from "react";
import Input from "../ui/Input";
import { addISBNDashes, calculateProfitMargin, calculateSellPrice, centsToPrice, convertDiscountToInt, fillTemplate, formatPhoneNumber, getBindingLabel, getSupplierGroup, isPhoneNumber, isShipStatus, kbdEvent, setSupplierGroup, showConfirm, showNotifyContact, sumArray, sumByKey } from "../utils/Utils";
import { useTabs } from "../hooks/useTabs";
import { getSignal } from "../App";
import PriceField from "../ui/PriceField";
import Button from "../ui/Button";
import { KBD } from "../utils/Keybindings";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Checkbox from "../ui/Checkbox";
import { ROUTES } from "../utils/Routes";
import CustomersController from "../controllers/CustomersController";
import { createScreen } from "../hooks/createScreen";
import DateField from "../ui/DateField";
import { listen } from "../hooks/Listener";
import { showError, showMessage } from "../ui/Message";
import { pubCall, pubCallAsync } from "../utils/PubSub";
import { createModal } from "../hooks/createModal";
import InventoryPubstock from "./InventoryPubstock";
import DateInput from "../ui/DateInput";
import dayjs from "dayjs";
import ToolTip from "../ui/ToolTip";
import NumberPicker, { savePickerInput } from "./NumberPicker";
import Float from "../ui/Float";
import Divider from "../ui/Divider";
import SuppliersController from "../controllers/SuppliersController";
import { drawPicker } from "../popovers/Picker";
import { VALIDATE } from "../utils/Validators";
import { ENUMS } from "../utils/Enums";
import { AddIcon, InfoIcon } from "../utils/Icons";
import Select from "../ui/Select";
import SelectBox from "../ui/SelectBox";
import GroupPicker from "./GroupPicker";
import { checkSupplierCondition } from "../controllers/InventoryController";



const completeDeleteOrder = (_order, controller, route, onBefore = () => { }, callback = () => { }) => {

    const { order_id } = _order;
    showConfirm({
        controller: controller,
        route: route,
        description: <div style={{ "textAlign": "center" }}>Delete this order?</div>,
        title: "Warning",
        callback: (e) => {
            if (e) {
                onBefore();
                pubCall("order.removeItem", { order_id: order_id, require_clerk_code: true }, (_s, _r) => {
                    if (_s) {
                        showMessage("Order removed.");
                    } else {
                        showError(_r);
                    }
                    callback(_s, _r);
                })
            } else {
                callback(false);
            }
        }
    })
};

export const deleteOrder = (_order, controller, route, onBefore = () => { }, callback = () => { }) => {
    if (_order?.customer) {
        drawPicker({
            controller: controller,
            allow_keys: true,
            show_keys: true,
            value: "0", title: "Caution! This is a customer's special order.", closeable: false, height: 300, route: route, callback: (e) => {

                switch (e) {
                    case "0":
                        return;
                        break;
                    case "1":
                        setTimeout(() => {
                            updateOrderQuantity(_order.quantity, { ..._order, "customer": null }, (_s, _r) => {
                                if (_s) {
                                    showMessage("Customer removed.")
                                } else {
                                    showError(_r)
                                }

                                callback(_s, _r)
                            });
                        }, 10)

                        break;
                    case "2":
                        setTimeout(() => {
                            completeDeleteOrder(_order, controller, route, onBefore, callback);
                        }, 10)
                        break;
                }

            }, offset: [0, 10],
            options: [
                { key: KBD.Digit0, value: "0", label: "Don't do anything.", },
                { key: KBD.Digit1, value: "1", label: "Remove the customer information but leave this as on order (for stock)." },
                { key: KBD.Digit2, value: "2", label: "Delete both the customer information and the order." },
            ]
        })

    } else {
        completeDeleteOrder(_order, controller, route, onBefore, callback);
    }
};

export const updateOrderQuantity = (_quantity = 1, _order, callback = () => { }) => {
    pubCall("order.editItem", { order_item: { ..._order, "quantity": _quantity }, require_clerk_code: true }, (_s, _r) => {
        callback(_s, _r);
    })
}

export const updateOrderGroup = (_quantity = 1, _order, callback = () => { }) => {
    pubCall("order.editItem", { order_item: { ..._order, "order_separator": _quantity }, require_clerk_code: true }, (_s, _r) => {
        callback(_s, _r);
    })
}


export const drawOrderHeaders = () => {
    return (
        <thead>
            <tr>
                <th style={{ "textAlign": "left", width: "45px" }} key="qty">Qty</th>
                <th style={{ "textAlign": "left", width: "75px" }} key="order">Order</th>
                <th style={{ "textAlign": "left", width: "34px" }} key="grp">Grp</th>
                <th style={{ "textAlign": "left", width: "74px" }} key="sup">SupPr</th>
                <th style={{ "textAlign": "left", width: "36px" }} key="disc">Disc</th>
                <th style={{ "textAlign": "left", width: "74px" }} key="sell">Sell</th>
                <th style={{ "textAlign": "left", width: "39px" }} key="pm">PM</th>
                <th style={{ "textAlign": "left", width: "20px" }} key="remove"></th>
                <th style={{ "textAlign": "left" }} key="customer"></th>
            </tr>
        </thead>
    )
}

export default function InventoryOrder(props) {

    const signal = getSignal();
    const session = signal?.session;
    const splitter = session?.is_splitter_active;
    const largestChainNum = Math.max(0, ...(session?.ms_info?.map(obj => obj.chain_num) ?? []));
    const stores = session?.ms_info.filter(item => item.is_splitter_active) ?? [];
    const myStoreIndex = stores.findIndex(item => item.san === session?.store_san);
    const full_split = useRef(new Array(largestChainNum + 1).fill(0));
    const supplierRequest = useRef(0);
    const [allowDefaultSupplier, setAllowDefaultSupplier] = useState(false);


    const [loading, setLoading] = useState(false);

    // Callbacks & Props
    const {
        controller = "",
        edit = true,
        route = "",
        onSave = () => { },
        onOpenFull = () => { },
        onRemove = () => { },
        updateSellPrice = () => { },
        onExit = () => { },
        onNew = () => { },
        onSelect = () => { },
        show_headers = false,
        selected = "",
        is_active = false,
        setSelected = () => { },
        customerRequired = false,
        full = true,
        pubstock = false,
        fullData = {},
        reserveFromOrder = false,
    } = props;



    const {
        sell_price = 0,
    } = fullData?.stock || {};



    const onEdit = (fieldKey) => {
        props.onEdit(true);
        if (fieldKey) {
            requestAnimationFrame(() => {
                setIndex(fieldKey);
            });
        }
    };



    // Order object
    const {
        order = {
            cancel_date: null,
            clerk_code: "",
            condition_code: "",
            customer: null,
            customer_po: "",
            invoice: "",
            invoice_date: null,
            invoice_price: 0,
            is_single_title_order: false,
            ms_split: [],
            note: [],
            order_id: "",
            order_number: "",
            order_separator: "",
            po_number: "",
            primary_code: "",
            quantity: 0,
            review_days: 0,
            status: "",
            status_date: 0,
            supplier: "",
            supplier_discount: 0
        }
    } = props;

    const exchange_rate = order.exchange_rate || 1;


    const init_order = useRef(order?.supplier);




    useEffect(() => {



        const updateSupp = (e) => {

            if (e?.detail?.supplier) {
                if (e?.detail?.supplier.length === 4) {
                    update("supplier", e?.detail.supplier)
                } else {
                    update("supplier", e?.detail.supplier.slice(0, 3))
                }
            }
        }
        window.addEventListener("updatePubstock", updateSupp);
        return () => {
            window.removeEventListener("updatePubstock", updateSupp)
        };
    }, []);





    const [open, setOpen] = useState(full);

    // Synthetic
    const store_profit_margin = calculateProfitMargin(sell_price, order.invoice_price, order.supplier_discount, exchange_rate)

    // Fields array to hold data and traverse

    const start_index = () => {

        if (reserveFromOrder) {
            return "customer.name"
        }

        if (order.status.startsWith("R")) {
            return "note.0"
        }

        if (order.status.startsWith("O")) {
            return "order_number"
        }

        if (canFieldEdit("quantity")) {
            return "quantity"
        }

        return "note.0"

    }

    const canFieldEdit = (_key) => {

        if (!full) {
            return true;
        }

        if (!edit) {
            return false;
        }

        if (!full) {
            return false;
        }

        if (order?.status !== "Rcvd") {
            return true;
        }
        if (["cancel_date", "sell_price", "store_profit_margin", "note.0", "note.1", "note.2", "customer.name", "customer.communication_preference", "customer_po"].includes(_key)) {
            return true;
        }
        return false;
    }

    const fields = [
        { type: "full", key: "status", value: order.status, skip: !canFieldEdit("quantity") },
        { type: "full", key: "status_date", value: (order.status_date) ? dayjs(order.status_date).format("YYYY-MM-DD HH:mm:ss") : dayjs().format("YYYY-MM-DD HH:mm:ss"), skip: !canFieldEdit("quantity") },

        { type: "full", key: "order_number", value: order.order_number || "", skip: (!order.status.startsWith("O")) },

        // { type: "full", key: "primary_code", value: order.status_date || dayjs().valueOf(), skip: (order?.status === "Rcvd" || true) },
        { type: "full", key: "cancel_date", value: (order.cancel_date) ? dayjs(order.cancel_date).format("YYYY-MM-DD HH:mm:ss") : "", skip: !canFieldEdit("quantity") }, // don't have yet
        // { type: "full", key: "inventory_number", value: order.inventory_date || "" }, // don't have yet
        // { type: "full", key: "invoice_date", value: order.invoice_date || "", skip: true }, // don't have yet
        { type: "row", key: "quantity", autoselect: false, value: order.quantity, skip: !canFieldEdit("quantity") },
        { type: "row", key: "splitter", value: "", skip: !splitter },
        { type: "full", key: "ms_split", value: order.ms_split, skip: true },
        { type: "row", key: "customer", value: order.customer, skip: true },
        { type: "full", key: "customer.name", value: order?.customer?.name || "" },

        { type: "full", key: "customer.email", value: order?.customer?.email || "", skip: true },
        { type: "full", key: "customer.phone", value: order?.customer?.phone || "", skip: true },
        { type: "full", key: "customer.phone2", value: order?.customer?.phone || "", skip: true },

        { type: "full", key: "customer.communication_preference", skip: (!order?.customer), value: order?.customer?.communication_preference || "" },
        { type: "full", key: "customer_po", label: "CustPO", skip: (!order?.customer), value: order.customer_po },
        { type: "row", key: "supplier", value: order.supplier, skip: !canFieldEdit("supplier") },

        { type: "row", key: "supplier_name", value: order?.supplier_name, skip: true },
        { type: "row", key: "supplier_currency", value: order?.supplier_currency, skip: true },

        { type: "row", key: "order_separator", value: (order?.order_id) ? order.order_separator : "", skip: !canFieldEdit("order_separator") },
        { type: "row", key: "default_supplier", value: "N", skip: !allowDefaultSupplier || !canFieldEdit("supplier") },
        { type: "row", key: "invoice_price", value: order.invoice_price, skip: !canFieldEdit("invoice_price") },
        { type: "row", key: "supplier_discount", value: order.supplier_discount, skip: !canFieldEdit("supplier_discount") },
        { type: "row", key: "sell_price", value: sell_price, skip: !canFieldEdit("sell_price") }, // Sell price comes from title data... 
        { type: "row", key: "store_profit_margin", value: store_profit_margin, skip: !canFieldEdit("store_profit_margin") }, // Sell price comes from title data... 
        { type: "row", key: "remove", value: "", skip: (!order?.order_id || full) }, // Remove button
        { type: "row", key: "expand", value: "", skip: full }, // Open Button 
        { type: "full", key: "shop", value: order?.customer?.shop || "", skip: true },
        { type: "full", key: "ship_to", value: order?.customer?.ship_to || "", skip: true },
        { type: "full", key: "note.0", autoselect: false, value: order?.note?.[0] || "", skip: false },
        { type: "full", key: "note.1", autoselect: false, value: order?.note?.[1] || "", skip: false },
        { type: "full", key: "note.2", autoselect: false, value: order?.note?.[2] || "", skip: false },



        { type: "row", key: "exchange_rate", value: order?.exchange_rate ?? exchange_rate ?? 1, skip: true },


        // { type: "full", key: "is_single_title_order", type: "checkbox", value: order.is_single_title_order, skip: !canFieldEdit("is_single_title_order") },
        // { type: "full", key: "is_prepay", type: "checkbox", value: order.is_prepay, skip: !canFieldEdit("is_prepay") },
        // { type: "full", key: "is_direct_to_home", type: "checkbox", value: order.is_direct_to_home, skip: !canFieldEdit("is_direct_to_home") },
        { type: "full", key: "review_days", value: order.review_days, skip: !canFieldEdit("review_days") },
        { type: "full", key: "review_date", value: (order.status_date) ? dayjs(order.status_date).add(order.review_days || 0, "days").format("YYYY-MM-DD HH:mm:ss") : dayjs().format("YYYY-MM-DD HH:mm:ss"), skip: !canFieldEdit("review_date") },

    ]

    const hasSplit = (arr) => { return arr.slice(1).some(val => val > 0); };






    const splitterIndex = fields.findIndex(tab => tab.key === "ms_split");

    if (splitter && splitterIndex !== -1) {

        const count = sumArray(order.ms_split);

        // put in value in their selected store

        const storeTabs = stores.map((item, index) => ({
            splitter: true,
            key: item.san,
            type: "row",
            skip: false,
            value: ((!order?.order_id || !count) && myStoreIndex === index) ? order.quantity : order.ms_split[index],
        }));
        // insert right after the splitter
        fields.splice(splitterIndex + 1, 0, ...storeTabs);
    }

    const filtered_fields = (full) ? fields : (splitter) ? fields.filter(item => item.type === "row") : fields.filter(item => item.type === "row" && item.key !== "splitter")

    const { tabs, index, help, update, updateSkip, setIndex, next, prev, refs, getVal, setTabs } = useTabs(filtered_fields, start_index);



    const currentExchangeRate = () => Number(getVal("exchange_rate")) || 1;



    const has_split = hasSplit(getVal("ms_split"));
    const has_customer = getVal("customer");

    useEffect(() => {
        if (splitter) {

            if (has_customer) {
                let _update = {};
                stores.forEach(element => {
                    _update[element.san] = true
                });
                updateSkip(_update)
            } else {
                let _update = {};
                stores.forEach(element => {
                    _update[element.san] = false
                });
                updateSkip(_update)
            }

            if (has_split) {
                updateSkip("customer.name", true);
            } else {
                updateSkip("customer.name", false);
            }

        }
    }, [has_split, has_customer])


    const [isValid, setIsValid] = useState(true);

    useEffect(() => {
        if (!isValid) {
            setTimeout(() => {
                setIndex("supplier")
            }, 10)

        }
    }, [index])


    // useEffect(() => {
    //     const run = async () => {
    //         const res = await pubCallAsync("supplier.getSingle", { code: order.supplier });

    //         if (!res?.supplier) {
    //             setIndex("supplier")
    //             setIsValid(false);
    //         }
    //     };

    //     run();
    // }, []);


    useEffect(() => {

        if (!splitter || stores?.length < 1) {
            return;
        }

        const hasCustomer = getVal("customer");
        const obj = stores.reduce(
            (acc, item) => {
                acc[item.san] = hasCustomer;
                return acc;
            },
            { splitter: hasCustomer }
        );
        updateSkip(obj);
    }, [getVal("customer")]);


    useEffect(() => {
        if (hasSplit(getVal("ms_split"))) {
            updateSkip({ ["customer.name"]: true })
        } else {
            updateSkip({ ["customer.name"]: false })
        }
    }, [getVal("ms_split")]);



    useEffect(() => {
        if (!edit) return;

        const el = refs?.current[index];
        if (el && typeof el.focus === "function") {
            el.focus();
        }
    }, [index, edit]);

    useEffect(() => {

        // Return if not in edit mode 
        if (!edit) {
            return;
        }

        const actions = [
            { key: KBD.ESCAPE, action: exit },
            { key: KBD.TAB, action: next },
            { key: KBD.SHIFT_TAB, action: prev },
            { key: KBD.PAGE_DOWN, action: () => { saveOrder() } },
            { key: KBD.CTRL_S, action: () => { saveOrder() } },

        ];

        if (full) {
            actions.push({ key: KBD.ARROW_DOWN, action: next });
            actions.push({ key: KBD.ARROW_UP, action: prev });
        }

        const cleanup = listen(controller, route, actions, () => { }, [
            KBD.ARROW_DOWN,
            KBD.ARROW_UP,
            KBD.TAB,
            KBD.SHIFT_TAB,
            KBD.ESCAPE,
            KBD.ENTER,
            KBD.PAGE_UP,
            KBD.PAGE_DOWN,
            KBD.CTRL_C,
            KBD.CTRL_V,
            KBD.CTRL_S
        ]);

        return cleanup;
    }, [index, tabs, edit]);


    function arrayToObject(arr) {
        return arr.reduce((obj, item) => {
            if (item.key) {
                obj[item.key] = item.hasOwnProperty("value") ? item.value : null;
            }
            return obj;
        }, {});
    }


    const checkSupplierPrice = (_new_price, _supplier_price, _supplier_name) =>


        new Promise(resolve => {
            drawPicker({
                controller: controller,
                value: _new_price, title: "Price doesn't match supplier's Pubstock Price", description: "Price doesn't match supplier's Pubstock Price.", closeable: false, height: 300, ref: null, route: route, close: () => { }, callback: (e) => {

                    resolve(e)
                }, offset: [0, 10],
                options: [{ value: _new_price, label: "Use " + centsToPrice(_new_price) + " anyway" }, { value: _supplier_price, label: "Use " + _supplier_name + " price: " + centsToPrice(_supplier_price).toString() },]
            })
        });




    const changeSellPrice = (_sell_price) =>
        new Promise(resolve => {

            showConfirm({
                controller: controller,
                route,
                description: (
                    <div style={{ textAlign: "center", "width": "330px" }}>
                        You are changing the inventory price: from<strong> {centsToPrice(sell_price)}</strong> to <strong>{centsToPrice(_sell_price)}</strong>.
                        <div className="shim" /><div>Are you sure?</div><div className="shim" />
                    </div>
                ),
                title: "Inventory price change",
                callback: confirmed => {
                    if (confirmed) {
                        resolve({
                            sell_price: _sell_price,
                            profit_margin: calculateProfitMargin(_sell_price, order.invoice_price, order.supplier_discount, currentExchangeRate())
                        })
                    } else {
                        update("sell_price", sell_price);
                        update("store_profit_margin", calculateProfitMargin(sell_price, order.invoice_price, order.supplier_discount, currentExchangeRate()))
                        resolve({
                            sell_price: sell_price,
                            profit_margin: calculateProfitMargin(sell_price, order.invoice_price, order.supplier_discount, currentExchangeRate())
                        })
                    }

                }
            });
        });

    const saveOrder = async () => {



        requestAnimationFrame(() => { })
        // blur input


        // convert array to keyed object (need to convert to an order object later)
        const _upd = arrayToObject(tabs);

        let _update = { ..._upd };

        if (_update?.default_supplier === "Y") {
            _update.default_supplier = true;
        } else {
            _update.default_supplier = false;
        }

        if (!_update.order_number) {
            delete _update.order_number;
        } else {
            _update.order_number = String(_update.order_number)
        }

        // new from titlelink - use the supplier...
        if (props.new_from_titlelink) {
            _update.default_supplier = true;
        }


        if (_update?.cancel_date) {
            _update.cancel_date = dayjs(_update.cancel_date).valueOf()
        } else {
            _update.cancel_date = null;
        }

        if (_update?.status_date) {
            _update.status_date = dayjs(_update.status_date).valueOf()
        } else {
            _update.status_date = 0;
        }

        // Supplier required - Might need to check against supplier list too
        if (_update?.supplier.length < 1 && _update?.supplier?.length > 4) {

            showError({ error: "Valid Supplier required" });
            setIndex("supplier");
            return;
        }

        // Check for customer
        if (customerRequired && !_update?.customer) {
            showError({ error: "Customer is required" });
            setIndex("customer");
            return;
        }


        // Check pubstock

        blurField();

        if (!fullData?.stock?.total_onhand) {
            let _f = fullData?.pubstock.find(item => item.supplier.slice(0, _update?.supplier.length).toLowerCase() === _update?.supplier.toLowerCase())
            if (_f) {
                if (_f.sell_price !== _update.sell_price) {
                    const check_price_updated = await checkSupplierPrice(_update.sell_price, _f.sell_price, _f.supplier);
                    if (!check_price_updated) return;
                    _update.sell_price = check_price_updated;
                }
            }
        }

        // Check if title and supplier condition code match
        const supplier = await pubCallAsync("supplier.getSingle", { code: _update.supplier })
        if (!supplier.code) {
            focusField();
            return
        };

        if (fullData?.stock?.condition_code !== supplier?.vendor_type) {
            const response = await new Promise((resolve) => {
                checkSupplierCondition(fullData?.stock, supplier, (res) => {
                    resolve(res);
                });
            });
            if (!response) {
                focusField();
                return
            }
        }

        // Check if quantity has changed and is ship status, then provide confirm prompt
        if (order.quantity !== _update.quantity) {
            // quantity changed...
            if (isShipStatus(_update.status)) {
                const ok = await new Promise((resolve) => {
                    showConfirm({
                        route: route,
                        title: "Warning",
                        description: <div style={{ "textAlign": "center" }}>
                            <div>You are changing the quanity of a sent PO. <div className="shim" />Use [R]eserve instead if you are adding a customer name. </div>
                            <div className="shim" /><div className="shim" />
                            <strong>Is this OK?</strong>
                        </div>,
                        callback: (result) => resolve(result === true)
                    });
                });

                if (!ok) {
                    focusField();
                    return
                };
            }
        }






        // if sell price is modified, update the title object (wait before continuing...)
        if (sell_price !== _update.sell_price) {
            if (!fullData?.stock?.total_onhand) {
                // don't ask...
                updateSellPrice(_update.sell_price);
            } else {
                const sell_price_updated = await changeSellPrice(_update?.sell_price);
                if (!sell_price_updated) return;

                _update.sell_price = sell_price_updated?.sell_price || _update.sell_price;
                _update.store_profit_margin = sell_price_updated?.store_profit_margin || _update.store_profit_margin;
            }
        }




        //
        if (_update?.customer) {
            _update.ms_split = [];
        }




        // Start order stuff
        setLoading(true);

        // Check quantity and remove if zero
        if (_update.quantity === 0) {
            if (order?.order_id) {
                removeOrder(order);
            } else {
                focusField();
                showError({ error: "Quantity required." })
            }
            setLoading(false);
            return;
        }


        // Create the order object
        let _order = fillTemplate(order, _update);

        // Add notes

        if (_update) {


            _order.note = [];
            if (_update["note.0"]) {
                _order.note.push(_update["note.0"])
            }
            if (_update["note.1"]) {
                _order.note.push(_update["note.1"])
            }
            if (_update["note.2"]) {
                _order.note.push(_update["note.2"])
            }



            //_order.note =[_update["note.0"] || "", _update["note.1"] || "", _update["note.2"] || ""]
        }

        // Add or edit depending on ID

        // Remember the supplier group
        // if(_update.order_separator){
        //     setSupplierGroup(_update.supplier, _update.order_separator);
        // }

        let _request_obj = {
            order_item: _order,
            require_clerk_code: true,
            is_new_stock: (props.new_from_titlelink) ? true : false
        }

        if (_request_obj?.order_item?.customer) {
            _request_obj.order_item.customer.communication_preference = getVal("customer.communication_preference")
        }


        let _api = (_order?.order_id) ? "order.editItem" : "order.addItem";


        if (reserveFromOrder) {

            // Change API, add FROM, option to replenish2

            _api = "order.reserveFromItem";
            _request_obj.new_order_item = _request_obj.order_item;

            showConfirm({
                controller: controller,
                route,
                description: (
                    <div style={{ textAlign: "center", "width": "330px" }}>
                        You are reserving against an existing stock order.
                        <div className="shim" /><div>Do you want to replenish the qty you are reserving with a Pending order?</div><div className="shim" />
                    </div>
                ),
                title: "Inventory replenish",
                callback: replenish => {

                    pubCall(_api, { ..._request_obj, "from_order_item_id": reserveFromOrder?.order_id, "replenish": replenish, default_supplier: _update.default_supplier }, (_s, _r) => {
                        if (_s) {
                            showMessage("Order added.")
                            savePickerInput(_request_obj?.quantity);
                            onSave(_r);
                            //props.callback(true);
                        } else {
                            focusField();
                            showError(_r);
                        }
                        setLoading(false);
                    })
                }
            });


        } else {


            pubCall(_api, _request_obj, (_s, _r) => {
                if (_s) {
                    showMessage((_order?.order_id) ? "Order updated" : "Order added");
                    savePickerInput(_order?.quantity);
                    onSave(_r);
                    if (full) {
                        //props.callback(true);
                    }
                } else {

                    if (_r?.kwargs?.message === "Supplier does not exist in your suppliers") {
                        update("supplier", "");
                        setIndex("supplier");
                    } else {
                        focusField();
                    }

                    showError(_r)
                }
                setLoading(false);
            })

        }



    }

    const blurField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.blur === 'function') {
            el.blur();
        }
    }

    const focusField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
    }


    const removeOrder = (_order) => {

        blurField();
        deleteOrder(_order, controller, route, () => {
            setLoading(true)
        }, (_s, _r) => {
            if (_s) {
                onRemove(_order?.order_id);
                onSave()
            } else {
                focusField();
            }
        })

    };

    const exit = () => {
        blurField();
        onExit()
    }


    const editProps = (key) => {

        const tab = tabs.find(tab => tab.key === key) || {};
        let _edit = (full) ? canFieldEdit(key) : edit;



        return {
            onFocus: () => { setIndex(key) },
            onMouseDown: () => {
                if (!edit) {
                    onEdit(key);
                }
            },
            ref: el => (refs.current[key] = el),
            edit: _edit,
            dataId: key,
            controlled: tab.controlled ?? true,
            autoselect: tab.autoselect ?? true,
            value: getVal(key),
            onChange: tab.onChange ?? (e => update(key, e)),
            onEnter: () => next()
        };
    };


    const updateSplit = (source, changedValue) => {



        const rawMsValues = getVal("ms_split");
        let ms_values = [...stores].map(() => 0);

        if (Array.isArray(rawMsValues) && rawMsValues.length === stores.length) {
            ms_values = [...rawMsValues];
        } else if (Array.isArray(rawMsValues) && rawMsValues.length > stores.length) {
            // Map to stores
            let _new = [];
            stores.forEach((store) => {
                _new.push(rawMsValues[store.chain_num]);
            });
            ms_values = _new;
        }

        const quantity = Number(getVal("quantity"));
        const numStores = stores.length;
        const primaryIndex = myStoreIndex;



        const setMsValuesAndQuantity = (newVals, overide_total = false) => {
            const total = newVals.reduce((a, b) => a + b, 0);


            // keep full_split in sync
            stores.forEach((store, index) => {
                if (full_split.current) {
                    full_split.current[store.chain_num] = newVals[index];
                }
            });

            // build updates for useTabs
            const updates = {
                ms_split: newVals,
                splitter: "",
                quantity: overide_total !== false ? overide_total : total,
            };
            stores.forEach((store, index) => {
                updates[store.san] = newVals[index];
            });


            // update both tabs + current
            update(updates);



        };



        if (source === "splitter") {
            const splitter = String(changedValue).trim();

            if (!splitter.includes(".")) {
                if (!isNaN(splitter) && parseInt(splitter) > 0) {
                    return updateSplit("quantity", changedValue);
                } else {
                    return updateSplit("quantity", getVal("quantity"));
                }
            }

            if (splitter === ".") {
                const even = Math.floor(quantity / numStores);
                const remainder = quantity % numStores;
                const newVals = ms_values.map((_, i) => i < remainder ? even + 1 : even);
                return setMsValuesAndQuantity(newVals);
            }

            if (splitter.startsWith(".")) {
                const q = Number(splitter.slice(1));
                if (isNaN(q)) return;
                const newVals = stores.map(() => q);
                return setMsValuesAndQuantity(newVals);
            }

            const match = splitter.match(/^(\d+)\.(\d+)$/);


            if (match) {

                const chainNum = parseInt(match[1]);
                const val = parseInt(match[2]);
                const storeIndex = stores.findIndex(s => s.row_number === chainNum);
                if (storeIndex === -1) return;

                const newVals = [...ms_values];
                newVals[storeIndex] = val;

                return setMsValuesAndQuantity(newVals);
            }

            return;
        }

        if (source === "quantity") {

            const newQuantity = Number(changedValue);
            const existingQuantity = Number(getVal("quantity"));
            if (newQuantity === existingQuantity) {
                return;
            }

            const currentTotal = ms_values.reduce((a, b) => a + b, 0);
            const delta = newQuantity - currentTotal;

            const newVals = [...ms_values];

            if (delta > 0) {
                newVals[primaryIndex] += delta;
            } else if (delta < 0) {
                let currentTotal = newVals.reduce((a, b) => a + b, 0);
                while (currentTotal > newQuantity) {
                    let maxIndex = 0;
                    for (let i = 1; i < newVals.length; i++) {
                        if (newVals[i] >= newVals[maxIndex]) {
                            maxIndex = i;
                        }
                    }
                    newVals[maxIndex] -= 1;
                    currentTotal -= 1;
                }
            }

            setMsValuesAndQuantity(newVals);
            return;
        }

        if (typeof source === "number") {

            const idx = source;
            const inputVal = Number(changedValue);
            if (isNaN(inputVal)) return;

            if (inputVal === ms_values[idx]) {
                return;
            }

            const newVals = [...ms_values];
            newVals[idx] = inputVal;

            const newTotal = newVals.reduce((a, b) => a + b, 0);
            setMsValuesAndQuantity(newVals, newTotal);
            return;

            // Logic for balancing the quanity and giving priority to the primary store


            // const idx = source;
            // const inputVal = Number(changedValue);
            // if (isNaN(inputVal)) return;

            // if (inputVal === ms_values[idx]) {
            //     return;
            // }

            // const oldVal = ms_values[idx];
            // const delta = inputVal - oldVal;
            // const newVals = [...ms_values];
            // newVals[idx] = inputVal;

            // if (idx === primaryIndex) {
            //     const newTotal = newVals.reduce((a, b) => a + b, 0);
            //     setMsValuesAndQuantity(newVals, newTotal);
            // } else {
            //     const primaryVal = newVals[primaryIndex];
            //     const reduction = Math.min(primaryVal, delta);
            //     newVals[primaryIndex] = primaryVal - reduction;

            //     const newTotal = newVals.reduce((a, b) => a + b, 0);
            //     setMsValuesAndQuantity(newVals, newTotal);
            // }

            // return;
        }
    };


    function getContactOptions(phone = "", phone2 = "", email = "") {
        const optionsMap = new Map();

        const addOption = (value, label, field) => {
            if (!optionsMap.has(value)) {
                optionsMap.set(value, { value, label, field });
            }
        };

        const phoneFields = [
            { value: phone, name: "phone" },
            { value: phone2, name: "phone_2" }
        ];

        const suffixMap = {
            Cel: { value: "C", label: "Cell" },
            CelX: { value: "C", label: "Cell" },
            Hom: { value: "H", label: "Home" },
            Wrk: { value: "W", label: "Work" },
            Fax: { value: "F", label: "Fax" }
        };

        let hasAnyPhone = false;
        let hasTextablePhone = false;

        phoneFields.forEach(({ value, name }) => {
            if (!value || !value.trim()) return;

            const trimmed = value.trim();
            hasAnyPhone = true;

            // Check suffix matches
            let matchedSuffix = false;
            for (const suffix in suffixMap) {
                if (trimmed.endsWith(suffix)) {
                    const opt = suffixMap[suffix];
                    addOption(opt.value, opt.label, name);
                    matchedSuffix = true;

                    // Only Cel / CelX count as textable
                    if (suffix === "Cel" || suffix === "CelX") {
                        hasTextablePhone = true;
                    }
                }
            }

            // If no suffix OR suffix is Cel/CelX → counts as textable
            if (!matchedSuffix) {
                hasTextablePhone = true;
            }
        });

        // Add P if any phone exists
        if (hasAnyPhone) {
            addOption("P", "Phone", "phone");
        }

        // Add T if any textable phone
        if (hasTextablePhone) {
            addOption("T", "Text", "phone");
        }

        // Add E if email exists
        if (email && email.trim()) {
            addOption("E", "Email", "email");
        }

        return Array.from(optionsMap.values());
    }


    const selectNotify = (_ref, _value, _rowIndex) => {
        blurField("customer.communication_preference");
        drawPicker({
            controller: controller,
            value: _value, title: "Notify Via", closeable: true, height: 300, ref: null, route: route, close: () => { focusField("customer.communication_preference"); }, callback: (e) => {
                if (e) {
                    update("customer.communication_preference", e);
                    setTimeout(() => {
                        kbdEvent(KBD.TAB);
                    }, 100)
                }
                focusField("customer.communication_preference");
            }, offset: [0, 10],
            options: getContactOptions(getVal("customer.phone"), getVal("customer.phone_2"), getVal("customer.email"))
        })
    }


    const selectStatus = (_ref, _value) => {
        blurField("status");
        drawPicker({
            controller: controller,
            value: _value, title: "Select Status", closeable: true, height: 300, ref: null, route: route, close: () => { focusField("status") }, callback: (e) => {
                if (e) {
                    update("status", e)
                    setTimeout(() => {
                        kbdEvent(KBD.TAB);
                    }, 100)
                }
                focusField("status")
            }, offset: [0, 10],
            options: ENUMS.ORDER_STATUS
        })

    }

    const savedPhoneNumber = useRef("");
    const [customerValid, setCustomerValid] = useState("")



    const validateCustomer = (_customer_name) => {



        // unchanged
        if (_customer_name === order?.customer?.name) {
            return;
        }

        blurField();
        //savedPhoneNumber.current = "";
        setCustomerValid("")




        pubCall("customer.searchKeyword", { search_term: _customer_name, limit: 45 }, (_s, _r) => {
            if (_s) {

                if (_r.total === 0 && _customer_name) {
                    // not found
                    if (isPhoneNumber(_customer_name)) {
                        // save for later...
                        savedPhoneNumber.current = formatPhoneNumber(_customer_name);

                        update("customer", null);
                        setCustomerValid("No phone or account# match. Try by name.");
                        focusField();

                    } else {
                        if (_customer_name) {

                            showConfirm({
                                controller: controller,
                                route: route,
                                description: <div style={{ "textAlign": "center" }}>

                                    <div>Customer record for: "<em><strong>{_customer_name}</strong></em>" was not found.</div>
                                    <div className="shim" /> <div className="shim" />
                                    Create a new record?</div>,
                                title: "Not found",
                                callback: (e) => {
                                    if (e) {
                                        // create
                                        selectCustomer("", [], { name: _customer_name, phone: savedPhoneNumber.current });
                                    } else {
                                        update("customer", null);
                                        focusField()
                                    }
                                }
                            })
                        }
                    }

                }

                if (_r.total === 1) {
                    // single match
                    let _obj = _r.rows[0];
                    update({
                        ["customer.name"]: _obj.name,
                        ["customer.email"]: _obj.email,
                        ["customer.phone"]: _obj.phone,
                        "customer": _obj, ["customer.communication_preference"]: _obj.communication_preference,
                        "ship_to": _obj.ship_to,
                        "shop": _obj.shop
                    })
                    updateSkip({ ["customer.communication_preference"]: false, customer_po: false });
                    setTimeout(() => {
                        kbdEvent(KBD.TAB);
                    }, 100)
                }

                if (_r.total > 1) {
                    selectCustomer("", _r);
                }

                // if (_r.length === 1) {
                //     // Single result
                //     let _obj = _r[0];
                //     update({
                //         ["customer.name"]: _obj.name,
                //         ["customer.email"]: _obj.email,
                //         ["customer.phone"]: _obj.phone,
                //         "customer": _obj, ["customer.communication_preference"]: _obj.communication_preference,
                //         "ship_to": _obj.ship_to,
                //         "shop": _obj.shop
                //     })
                //     updateSkip({ ["customer.communication_preference"]: false, customer_po: false })
                // } else {
                //     if(_r.length === 0){
                //         showError({error : "Not found"});
                //     } else {
                //         selectCustomer(_customer_name, _r);
                //     }
                // }
            } else {
                // showError(_r);
            }
        });

    }

    const selectCustomer = (_search = "", initData = [], newCustomer = false) => {
        window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER;
        blurField("customer.name");
        createScreen({
            signal: signal,
            component: <CustomersController controller={controller} is_modal initData={initData} newCustomer={newCustomer} search={getVal("customer.name")} route={ROUTES.CUSTOMER.CUSTOMER} />, closable: false, title: "Select Customer",
            callback: (_obj) => {
                window.bm_state.value = route;

                if (_obj) {
                    update({
                        ["customer.name"]: _obj.name,
                        ["customer.email"]: _obj.email,
                        ["customer.phone"]: _obj.phone,
                        "customer": _obj, ["customer.communication_preference"]: _obj.communication_preference,
                        "ship_to": _obj.ship_to,
                        "shop": _obj.shop
                    })
                    updateSkip({ ["customer.communication_preference"]: false, customer_po: false })
                    setTimeout(() => {
                        kbdEvent(KBD.TAB);
                    }, 100)
                }
                focusField("customer.name");
            }
        });
    }

    const selectSupplier = (_search) => {
        window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER;
        blurField("supplier");
        createScreen({
            signal: signal,
            component: <SuppliersController controller={controller} is_modal search={_search} route={ROUTES.CUSTOMER.CUSTOMER} />, closable: false, title: "Select Supplier",
            callback: (_obj) => {
                if (_obj?.code) {
                    update({
                        "supplier": _obj?.code,
                        "supplier_name": _obj?.name,
                        "supplier_currency": _obj?.currency
                    });

                }
                window.bm_state.value = route;
                refs.current["supplier"].focus();
                setTimeout(() => {
                    kbdEvent(KBD.TAB);
                }, 100)

            }
        });
    }


    const splitter_instructions = <>
        <div className="shim" />
        <div>Splitter instructions</div>
        <Divider />
        <div>
            <Space><kbd>.</kbd><kbd>enter</kbd></Space>
            <div className="shim" />
            <Label style={{ "textAlign": "left" }}>Splits current quantity evening amongst stores</Label>
        </div>
        <div className="shim" /> <div className="shim" />
        <div>
            <Space><kbd>store number</kbd><kbd>.</kbd><kbd>quantity</kbd><kbd>enter</kbd></Space>
            <div className="shim" />
            <Label style={{ "textAlign": "left" }}>Assign a quantity to a specific store.</Label>
        </div>
        <div className="shim" /> <div className="shim" />
        <div>
            <Space><kbd>.</kbd><kbd>quantity</kbd><kbd>enter</kbd></Space>
            <div className="shim" />
            <Label style={{ "textAlign": "left" }}>Assign quantity to all stores.</Label>
        </div>
    </>



    const drawSplitter = (order) => {
        if (!splitter || stores?.length < 1) {
            return;
        }


        const is_disabled = (getVal("customer.name")) ? true : false;

        return (
            <Space size={8} style={{ "marginBottom": "-4px" }}>
                <Label width={47} style={{ "marginBottom": "-10px" }} ><ToolTip text={splitter_instructions}>Split</ToolTip></Label>
                <tr>
                    <td colSpan={9}>
                        <div style={{ "borderTop": "none", "width": "maxContent", "borderLeft": "none", "margin": "0px -6px", "padding": "0px 0px" }}>
                            <table style={{ "backgroundColor": "var(--card-bg)" }} className="">
                                <thead>
                                    <tr key={"splitter"}>
                                        <th style={{ "textAlign": "left" }}></th>
                                        {stores.map((store) => (
                                            <th style={{ "textAlign": "right" }} key={store.san}><Label style={{ "fontSize": "10px", "textAlign": "left", "marginBottom": "-5px" }}>#{store.chain_num}</Label></th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr key={"splitter_input"}>
                                        <td>

                                            <Input chars={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."]} {...editProps("splitter")} className={(is_disabled) ? "dim" : ""} onEnter={(e) => {
                                                if (e) {

                                                    updateSplit("splitter", e);
                                                } else {
                                                    if (hasSplit(getVal("ms_split"))) {
                                                        setIndex("supplier")
                                                    } else {
                                                        setIndex("customer.name");
                                                    }
                                                }
                                            }} onBlur={(e) => updateSplit("splitter", e)} width={50} /></td>
                                        {stores.map((store, index) => {
                                            const _ms = getVal("ms_split") || [6];
                                            const _value = getVal(store.san) || (_ms[store.chain_num] || 0)
                                            return (<td style={{ "textAlign": "right" }} key={store.san}><Input className={(is_disabled) ? "dim" : ""} {...editProps(store.san)} onEnter={(e) => {
                                                updateSplit(index, e);
                                                next();

                                            }} onChange={(e) => updateSplit(index, e)} number width={35} value={_value} /></td>)
                                        })}



                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </td>
                </tr>
            </Space>
        )
    }

    const handleReviewChange = (field, value) => {
        const statusDate = getVal("status_date")
            ? dayjs(getVal("status_date"))
            : dayjs(); // fallback to today

        if (field === "review_days") {
            const days = Number(value) || 0;

            update("review_days", days);
            update(
                "review_date",
                statusDate.add(days, "day").format("")
            );
        }

        if (field === "review_date") {
            const reviewDate = dayjs(value);
            const days = reviewDate.diff(statusDate, "day");

            update("review_date", reviewDate.valueOf());
            update("review_days", days);
        }
    };




    const updateFromSupplier = (_supplier) => {
        const supplierExchangeRate =
            Number(_supplier?.exchange_rate) || 1;

        const _t = {
            supplier:
                _supplier?.supplier?.length === 5
                    ? _supplier.supplier.slice(0, 3)
                    : _supplier?.supplier,

            invoice_price: _supplier?.invoice_price,
            supplier_discount: convertDiscountToInt(
                _supplier?.supplier_discount
            ),
            supplier_name: _supplier?.supplier_name,
            supplier_currency: _supplier?.supplier_currency,
            exchange_rate: supplierExchangeRate
        };

        if (_supplier.cancel_date) {
            _t.cancel_date = dayjs(_supplier.cancel_date).format("YYYY-MM-DD HH:mm:ss");
        }



        const supplierGroup = getSupplierGroup(_t.supplier);

        if (supplierGroup) {
            _t.order_separator = supplierGroup;
        }
        //!fullData?.stock?.total_onhand
        if (true) {
            const _f = fullData?.pubstock.find(item =>
                item.supplier
                    .slice(0, _supplier?.supplier?.length)
                    .toLowerCase() ===
                _supplier?.supplier?.toLowerCase()
            );

            if (_f) {

                _t.sell_price = _f.sell_price;
                _t.invoice_price = _f.supplier_price;



                _t.store_profit_margin = calculateProfitMargin(
                    _f.sell_price,
                    _t.invoice_price,
                    _t.supplier_discount,
                    supplierExchangeRate
                );
            }
        } else {
            _t.store_profit_margin = calculateProfitMargin(
                getVal("sell_price"),
                _t.invoice_price,
                _t.supplier_discount,
                supplierExchangeRate
            );
        }

        update(_t);
    };





    const drawQuantity = () => {

        if (splitter) {
            return (
                <NumberPicker active={(index === "quantity")} onSelect={(e) => { updateSplit("quantity", e); next() }}>
                    <Input
                        {...editProps("quantity")}
                        onEnter={(e) => { updateSplit("quantity", e); next() }}
                        onChange={(e) => updateSplit("quantity", e)}
                        width={45}
                        min
                        max={(reserveFromOrder) ? reserveFromOrder?.quantity : 999}
                        // className={(edit) ? "text-orange-bg" : "text-orange-bg text-black"}
                        number
                        right
                        style={{ margin: "0px 1px" }}
                    />
                </NumberPicker>
            )
        } else {
            return (
                <NumberPicker active={(index === "quantity")} onSelect={(e) => { update("quantity", e); next() }}>
                    <Input
                        // numpicker={true}
                        {...editProps("quantity")}
                        width={45}
                        min
                        max={(reserveFromOrder) ? reserveFromOrder?.quantity : 999}
                        // className={(edit) ? "text-orange-bg" : "text-orange-bg text-black"}
                        number
                        style={{ margin: "0px 1px" }}
                        right
                    />
                </NumberPicker>
            )
        }
    }


    const getSupplierPrice = (_supplier = "", _callback = () => { }) => {
        let _f = fullData?.pubstock.find(item => item.supplier.slice(0, _supplier?.length).toLowerCase() === _supplier?.toLowerCase())
        if (_f) {
            _callback(_f.sell_price)
        } else {
            _callback(false)
        }
    }




    return (
        <>
            <div onClick={() => {
                if (!edit) {
                    onEdit();
                }
            }} style={{ width: "auto", minHeight: `220px`, "backgroundColor": "var(--card-bg)", overflow: "hidden", display: "flex", flexDirection: "column", overflow: "hidden", "border": (edit) ? "2px solid var(--text-purple)" : "2px solid var(--text-dim)", "borderRadius": "5px" }}>
                <div className={"ui-table-header"} style={{ position: "relative" }}>
                    {/* {savedPhoneNumber.current} */}
                    <div style={{ marginLeft: "0px", "height": "20px", "overflow": "hidden" }}>
                        {(!order?.order_id && <div><Space style={{ "alignItems": "flex-start" }}><Label style={{ "color": "var(--text)" }}><nobr>Order for Stock or Customer:</nobr></Label><small style={{ "color": "var(--text-yellow)" }}>{fullData?.stock?.title} <em><small>({getBindingLabel(fullData?.stock?.binding)})</small></em></small></Space></div>)}
                        {(order?.order_id && <div><Float><Label style={{ "color": "var(--text)" }}>Editing Order</Label><Space>

                            <Label width={47}>Created</Label>
                            <DateInput width={100} value={dayjs(order?.req_date).format("YYYY-MM-DD HH:mm:ss")} />

                            <Label width={47}>Clerk</Label>
                            <Input width={40} value={order?.clerk_code} />

                        </Space></Float></div>)}
                    </div>
                </div>

                <div style={{ "border": "1px solid var(--border-secondary)", "borderBottom": "none", "padding": "5px" }}>
                    <div className="shim" />
                    <Float>
                        <Space>
                            <Label width={47}>Status</Label>


                            <Input {...editProps("status")}
                                icon={<AddIcon />}
                                onSearch={() => selectStatus(refs.current[`status`], getVal("status"))}
                                onPageUp={() => selectStatus(refs.current[`status`], getVal("status"))}
                                doubleclick={() => selectStatus(refs.current[`status`], getVal("status"))}
                                width={90}
                                edit={canFieldEdit("quantity")}
                            />
                            <Label width={47}><nobr>Date</nobr></Label>
                            <DateInput {...editProps("status_date")} onFilled={(e) => update("status_date", e)} edit={canFieldEdit("quantity")} width={89} />
                        </Space>
                        <Space>
                            <Label>Cancel</Label>
                            <DateInput {...editProps("cancel_date")} onFilled={(e) => update("cancel_date", e)} width={100} edit={canFieldEdit("quantity")} />
                        </Space>
                    </Float>
                    <div className="shim" />
                    <Float>
                        <Space>
                            <Label width={47}>Order</Label>
                            <Input maxLength={5} validator={VALIDATE.MIN(1)} uppercase width={70} {...editProps("order_number")} edit={order.status.startsWith("O")} />
                        </Space>
                        <Space>
                            <Label width={47}>Inv#</Label>
                            <Input width={110} value={order?.invoice || ""} />

                            <Label>InvDate</Label>
                            <DateInput {...editProps("invoice_date")} onFilled={(e) => update("invoice_date", e)} value={(order?.invoice) ? dayjs(getVal("invoice_date")).format("YYYY-MM-DD HH:mm:ss") : ""} width={100} edit={false} />
                        </Space>
                    </Float>
                    <div className="shim" />
                    <Space>
                        <Label width={47}>ISBN</Label>
                        <Input width={150} value={addISBNDashes(fullData?.stock?.primary_code, fullData?.stock?.condition_code, false)} edit={false} />
                        <Label><em>{fullData?.stock?.title} {(fullData?.stock?.binding && <>({fullData?.stock?.binding})</>)}</em></Label>
                    </Space>
                    <Divider style={{ "height": "10px" }} />
                    <Float>
                        <Space>
                            <Label width={47}>Qty</Label>
                            {drawQuantity()}
                        </Space>
                    </Float>
                    {drawSplitter(order)}
                    <div className="shim" />
                    <Space grow>
                        <Label width={47}>Cust</Label>
                        <Input feedback={(index === "customer.name" && customerValid) ? customerValid : ""} className={hasSplit(getVal("ms_split")) ? "dim" : ""} grow {...editProps("customer.name")}
                            onEnter={(e) => {
                                let _c = getVal("customer");
                                if ((e && _c?.name === e) || !e) {
                                    // didn't change anything.. just skip
                                    next();
                                } else {
                                    validateCustomer(e)
                                }
                            }}
                            onBlur={(e) => {
                                let _c = getVal("customer");
                                if (e && _c?.name && _c?.name !== e) {
                                    // changed it but didn't set...
                                    update("customer.name", _c.name)
                                }
                            }}
                            onClear={() => {
                                update("customer", null);
                            }}
                            onSearch={(e) => validateCustomer(e)}
                            onPageUp={(e) => validateCustomer(e)}
                            doubleclick={(e) => { validateCustomer(e.target.value) }}

                        />

                        <Label>&nbsp; Acct</Label>
                        <Input width={80} value={getVal("ship_to")} />
                        <Label>&nbsp; CustType</Label>
                        <Input style={{ "textAlign": "center" }} width={15} value={getVal("shop")} />
                    </Space>

                    <div className="shim" />
                    <Float>
                        <Space>
                            <Label width={47}><nobr>Notify</nobr></Label>

                            <SelectBox
                                {...editProps("customer.communication_preference")}
                                edit={(edit && getVal("customer"))}
                                allowKeys
                                keyfield="value"
                                width={70}
                                options={getContactOptions(getVal("customer.phone"), getVal("customer.phone_2"), getVal("customer.email"))}
                            />
                            {/* <Input
                                {...editProps("customer.communication_preference")}

                                icon={<AddIcon />}
                                onSearch={() => selectNotify(refs.current[`customer.communication_preference`], getVal("customer.communication_preference"))}
                                onPageUp={() => selectNotify(refs.current[`customer.communication_preference`], getVal("customer.communication_preference"))}
                                doubleclick={() => selectNotify(refs.current[`customer.communication_preference`], getVal("customer.communication_preference"))}

                                edit={(edit && getVal("customer"))}
                                className={(getVal("customer")) ? "" : "dim"} uppercase maxLength={1} width={61} /> */}
                            <Label style={{ "lineHeight": "12px" }}>{showNotifyContact(getVal("customer.email"), getVal("customer.phone"), getVal("customer.phone_2"), getVal("customer.communication_preference"))}</Label>
                        </Space>
                        <Space>
                            <Label width={60}>CustPO#</Label>
                            <Input {...editProps("customer_po")} edit={(edit && getVal("customer"))} className={(getVal("customer")) ? "" : "dim"} width={107} />
                        </Space>
                    </Float>
                    <div className="shim" />
                    <Space>
                        <Label width={47}>Suppl</Label>
                        <div style={{ "width": "77px", backgroundColor: "#1e1e1e" }}>
                            <Input
                                feedback={((index === "supplier" && !isValid) ? "Supplier required" : "")}
                                placeholder="Supp..."
                                {...editProps((!order?.order_id && !edit) ? "" : "supplier")}
                                dataId="supplier"
                                width={70}
                                valFunction={async (e) => {
                                    if (e?.length < 1 || e?.length > 4) {
                                        setIsValid(false);
                                        return null;
                                    }

                                    if (e === init_order?.current) {
                                        init_order.current = false;
                                        return;
                                    }

                                    const requestId = ++supplierRequest.current;


                                    const res = await pubCallAsync("order.getPlaceholderPending", { primary_code: fullData?.stock?.primary_code, condition_code: fullData?.stock?.condition_code, supplier_code: e });

                                    if (requestId !== supplierRequest.current) {
                                        return null;
                                    }

                                    if (res?.supplier) {

                                        updateFromSupplier(res);

                                        if (res?.supplier !== order?.supplier) {
                                            setAllowDefaultSupplier(true);
                                            updateSkip("default_supplier", false);
                                        } else {
                                            setAllowDefaultSupplier(false);
                                            updateSkip("default_supplier", true);
                                        }

                                        setIsValid(true)
                                    } else {

                                        setIsValid(false);
                                    }
                                    return (res?.supplier);
                                }}

                                onPageUp={(e) => {
                                    selectSupplier(e)
                                }}


                                // onChange={(e) => {
                                //     update("supplier", e)
                                // }}

                                // onFill={() => {
                                //     next();
                                // }}
                                maxLength={4}
                                uppercase
                                style={{ margin: "0px 1px" }}
                            />
                        </div>



                        <Label>&nbsp; Grp</Label>
                        <GroupPicker active={(index === "order_separator")} offset={[0, -25]} onSelect={(e) => { update("order_separator", e); next() }}>
                            <Input
                                {...editProps("order_separator")}
                                alpha
                                width={20}
                                maxLength={1}
                                style={{ margin: "0px 1px" }}
                                uppercase
                            />
                        </GroupPicker>

                        <Label>Dflt</Label>
                        <Input maxLength={1} width={20} {...editProps("default_supplier")} edit={edit && allowDefaultSupplier} className={allowDefaultSupplier ? "" : "dim"} onFill={() => next()} uppercase chars={["Y", "N"]} />




                        <Label><em>{getVal("supplier_name")} {(getVal("supplier_currency") && <>({getVal("supplier_currency")})</>)}</em></Label>
                    </Space>
                    <div className="shim" />
                    <Space>
                        <Label width={47}>InvPr</Label>
                        <PriceField
                            {...editProps("invoice_price")}
                            onChange={(e) => {
                                update({
                                    invoice_price: e,
                                    store_profit_margin: calculateProfitMargin(getVal("sell_price"), e, getVal("supplier_discount"), currentExchangeRate())
                                })
                            }}
                            width={70}
                            min
                            price
                            style={{ margin: "0px 1px" }}
                            right
                        />
                        <Input
                            {...editProps("supplier_discount")}
                            onChange={(e) => {
                                update({
                                    supplier_discount: e,
                                    store_profit_margin: calculateProfitMargin(getVal("sell_price"), getVal("invoice_price"), e, currentExchangeRate())
                                })
                            }}
                            width={30}
                            maxLength={2}
                            number
                            style={{ margin: "0px 1px" }}
                            right
                        />
                        <Label>%</Label>
                    </Space>
                    <div className="shim" />
                    <Space>
                        <Label width={47}>Sell</Label>
                        <PriceField
                            {...editProps("sell_price")}
                            onChange={(e) => {

                                if (e === 0 || e === "0") {
                                    getSupplierPrice(getVal("supplier"), (e) => {
                                        update("sell_price", (e) ? e : sell_price)
                                    });

                                    return;
                                }

                                update({
                                    sell_price: e,
                                    store_profit_margin: calculateProfitMargin(e, getVal("invoice_price"), getVal("supplier_discount"), currentExchangeRate())
                                })
                            }}
                            width={70}
                            min
                            price
                            right
                            style={{ margin: "0px 1px" }}
                        />
                        <Input
                            {...editProps("store_profit_margin")}
                            onChange={(e) => {
                                update({
                                    store_profit_margin: e,
                                    sell_price: calculateSellPrice(getVal("invoice_price"), getVal("supplier_discount"), e, currentExchangeRate())
                                })
                            }}
                            onEnter={() => { if (open) { next() } else { kbdEvent(KBD.PAGE_DOWN) } }}
                            width={30}
                            min
                            right
                            number
                            maxLength={2}
                            style={{ margin: "0px 1px" }}
                        />
                        <Label>PM</Label>
                    </Space>
                    <Divider style={{ "height": "10px" }} />
                    <Space>
                        <Label width={47}><nobr>Notes</nobr></Label>
                        <Space size={0} flexDirection="column">
                            <Input style={{ "borderBottomLeftRadius": "0px", "borderBottomRightRadius": "0px", "fontFamily": "var(--font-mono)", "fontSize": "17px" }} width={368} maxLength={40} {...editProps("note.0")} tabMax={() => refs.current[`note.1`].focus()} autoselect={false} edit={edit} />
                            <Input style={{ "borderRadius": "0px", "fontFamily": "var(--font-mono)", "fontSize": "17px" }} width={368} maxLength={40} {...editProps("note.1")} tabMin={() => refs.current[`note.0`].focus()} tabMax={() => { refs.current[`note.2`].focus(); }} autoselect={false} edit={edit} />
                            <Input style={{ "borderTopLeftRadius": "0px", "borderTopRightRadius": "0px", "fontFamily": "var(--font-mono)", "fontSize": "17px" }} width={368} maxLength={40} {...editProps("note.2")} tabMin={() => refs.current[`note.1`].focus()} autoselect={false} edit={edit} />
                        </Space>
                    </Space>
                    <Divider style={{ "height": "10px" }} />
                    <Float>
                        <Space>
                            <Label width={47}>Review</Label>
                            <Input number maxLength={3} {...editProps("review_days")} onChange={(e) => { handleReviewChange("review_days", e); }} onEnter={() => kbdEvent(KBD.PAGE_DOWN)} right width={33} />
                            <DateInput {...editProps("review_date")} onFill={(_v) => handleReviewChange("review_date", _v)} onFilled={(_v) => handleReviewChange("review_date", _v)} maxLength={10} width={89} />
                        </Space>
                        <Space size={20}>
                            <ToolTip text="STO: Single Title Order"><Checkbox disabled {...editProps("is_single_title_order")} onEnter={() => next()}><small>STO</small></Checkbox></ToolTip>
                            <Checkbox disabled {...editProps("is_prepay")} onEnter={() => next()}><small>Prepay</small></Checkbox>
                            <ToolTip text="DTO: Direct to Home"><Checkbox disabled {...editProps("is_direct_to_home")} onEnter={() => next()}><small>DTH</small></Checkbox></ToolTip>
                        </Space>
                    </Float>
                </div>

            </div>
            <div className="shim" />
            {(edit &&
                <Space size={5}>
                    <Button onClick={() => kbdEvent(KBD.PAGE_DOWN)} className="ui-save-button" type="primary">Save</Button>
                    <Button onClick={() => kbdEvent(KBD.ESCAPE)} className="ui-cancel-button" type="danger">Cancel</Button>
                    {(order?.order_id && <Button onClick={() => removeOrder(order)} className="ui-delete-button" type="danger">Delete Order</Button>)}
                </Space>
            )}


            {/* <div style={{ "margin": "10px 0px", "marginBottom": "0px", "border": "1px solid var(--border-secondary)", "minWidth": "610px" }}>
                <table style={{ width: "100%", backgroundColor: "var(--card-bg)" }} className={"ui-table stretch-last"}>
                    {drawOrderHeaders()}
                    {drawRow()}
                    {drawSplitter()}
                    {drawDetails()}
                </table>
            </div> */}

        </>)
}